import { LocationQuery } from 'vue-router';
import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { HitStatusType } from './hit-status-type.interface';
import { HitStatusTypeService } from './hit-status-type.service';

const service = new HitStatusTypeService();

export interface HitStatusTypeState {
   hitStatusTypes: Array<HitStatusType>;
}

const HitStatusTypeStore: Module<HitStatusTypeState, StoreState> = {
   namespaced: true,
   state: {
      hitStatusTypes: [],
   },
   getters: {},
   mutations: {
      SET_HIT_STATUS_TYPES(state: HitStatusTypeState, hitStatusTypes: Array<HitStatusType>) {
         state.hitStatusTypes = hitStatusTypes.sort((a, b) => {
            if (a.rank > b.rank) return -1;
            if (a.rank < b.rank) return 1;
            return 0;
         });
      },
   },
   actions: {
      async getHitStatusTypes(context, query: LocationQuery) {
         const { data: hitStatusTypes } = await service.getHitStatusTypes(query);
         context.commit('SET_HIT_STATUS_TYPES', hitStatusTypes);
         return hitStatusTypes;
      },
   },
};

export default HitStatusTypeStore;
